/* Self-contained module (spec.md §3.0 pattern). Applies to any autoplay/loop
   background video marked [data-pr-autoplay-video]: pauses it while scrolled
   out of view (no point decoding frames nobody sees) and never starts it at
   all for visitors who've asked the OS/browser for reduced motion — the video
   still renders via its poster frame, just static. */
(function () {
  var videos = document.querySelectorAll("[data-pr-autoplay-video]");
  if (!videos.length) {
    return;
  }

  var reduceMotion =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  videos.forEach(function (video) {
    if (reduceMotion) {
      video.pause();
      video.removeAttribute("autoplay");
      return;
    }

    if (!("IntersectionObserver" in window)) {
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(video);
  });
})();
